<template>
  <div class="goods__details">
    <div class="content">
      <SearchNav ref="searchNav" />
      <div class="goods__details__container" v-if="!requestError">
        <!-- 服务端暂时不支持查询目录层级，本期暂定不做 -->
        <!-- <el-breadcrumb class="nav__title" separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">商城首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">类目</a></el-breadcrumb-item>
          <el-breadcrumb-item>{{goodsInfo.itemName}}</el-breadcrumb-item>
        </el-breadcrumb> -->
        <div class="goods__details__container__main">
          <div class="flex space-between goods-img-wrap">
            <ImgList
              :isSpecial="isSpecial"
              :list="goodsInfo.itemMainImg"
              :itemStatus="goodsInfo.itemStatus"
            />
            <img class="goods-label" :src="goodsInfo.itemLabelIcon" v-if="goodsInfo.itemLabelIcon" />
            <GoodsDetails :goodsInfo="goodsInfo" :quertInfo="quertInfo" @update-goodsInfo="updateGoodsInfo" />
          </div>
          <DescripDetails v-if="goodsInfo" style="margin-top: 12px" :goodsInfo="goodsInfo" :key="goodsId" />
        </div>
        <div class="goods__details__container__aside">
          <StoreCard
            @contactCustomerService="onContactCustomerService"
            :storeInfo="goodsInfo.shopInfo"
            :shippingInfo="goodsInfo.shippingInfo"
          />
          <HotCard v-if="goodsInfo.shopInfo && goodsInfo.shopInfo.shopId" :shopId="goodsInfo.shopInfo.shopId" />
        </div>
      </div>
      <div v-else class="empty">
        <img class="empty__logo" src="@/assets/img/shop-empty.png" />
        <div class="empty__text">暂无商品信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import SearchNav from '@/components/SearchNav';
import ImgList from './components/ImgList';
import GoodsDetails from './components/GoodsDetails';
import DescripDetails from './components/DescripDetails';
import StoreCard from './components/StoreCard';
import HotCard from './components/HotCard';
import { mapGetters } from 'vuex';
import VueScrollTo from 'vue-scrollto';
const scrollOptions = {
  container: '.layout-component',
  duration: 50,
  lazy: false,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
};
export default {
  components: {
    SearchNav,
    ImgList,
    GoodsDetails,
    DescripDetails,
    StoreCard,
    HotCard
  },
  computed: {
    ...mapGetters({
      groupChat: 'imChatService/getPcGroupChat',
      groupList: 'imChatService/getPcGroupList'
    }),
    goodsId() {
      return this.$route.params.id;
    },
    isSpecial() {
      return this.goodsInfo.activityType === 'SPECIAL_PRICE'
    }
  },
  watch: {
    $route() {
      VueScrollTo.scrollTo('.el-header', 150, scrollOptions);
      this.init();
    }
  },
  data() {
    return {
      goodsInfo: { itemMainImg: [], itemSalePrice: '', itemLinePrice: '', saleUnit: '', itemName: '', itemStatus: '' },
      quertInfo: {
        shopId: '',
        minBuyCount: 1, // 起购数
        maxBuyCount: 99999, // 最大限购数量
        stockNumber: 99999, // 库存
        buyMultiple: 1 // 购买倍数
      },
      requestError: false
    };
  },
  mounted() {
  },
  methods: {
    init() {
      this.getGoodsInfo();
      this.getBuyGoodsInfo();
    },
    async getGoodsInfo() {
      this.requestError = false;
      try {
        const goodsInfo = await api.goods.getGoodsInfo({
          itemCode: this.goodsId
        });
        this.goodsInfo = goodsInfo;
        Telescope.trackPage({
          trackId: 'zyb2bpc-page-spxqy-spxqyB2B',
          custom: {
            good_status: goodsInfo.itemStatus === 2 ? '售罄' : '非售罄',
          }
        })
      } catch (error) {
        this.requestError = true;
      }
    },
    // 查询商品购买限制信息接口
    async getBuyGoodsInfo() {
      const res = await api.cart.queryPurchaseRestrictionsInformation({ itemCode: this.goodsId });
      this.quertInfo = res;
    },
    async onContactCustomerService() {
      const res = await api.shop.creatSession({
        storeId: this.goodsInfo.shopInfo.merchantId
      });
      const { groupId } = res;
      this.$store.commit('imChatService/SET_WAITSENDCONFIG', {
        imgUrl: this.goodsInfo.itemMainImg[0],
        summary: this.goodsInfo.itemTitle,
        type: 'merchandise',
        price: this.goodsInfo.itemSalePrice / 100, //做下单位换算
        itemCode: this.goodsId,
        groupId
      });
      this.$store.dispatch('imChatService/SET_CHAT_GID', groupId);
      this.$nextTick(() => {
        this.groupList.GroupListInit();
        this.groupChat.init();
      });
      this.$store.dispatch('imDialogService/openDialog');
    },
    updateGoodsInfo() {
      this.getBuyGoodsInfo();
      // 加购成功获取购物车数量
      this.$refs.searchNav.updateCartNum();
    }
  },
  created() {
    this.init();
    VueScrollTo.scrollTo('.el-header', 150, scrollOptions);
  }
};
</script>

<style lang="scss" scoped>
.goods__details {
  &__container {
    .nav__title {
      padding: 12px 0;
    }
    &__main {
      float: left;
      width: 985px;
      .goods-img-wrap {
        position: relative;
        .goods-label {
          position: absolute;
          top: 0;
          left: 0;
          height: 32px;
        }
      }
    }
    &__aside {
      float: right;
      width: 219px;
    }
    ::v-deep .el-breadcrumb__item {
      font-size: 12px;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 1;
    }
    ::v-deep .el-breadcrumb__inner {
      color: #8c8c8c;
    }
  }
  .empty {
    padding: 238px 0;
    text-align: center;
    background: #f5f5f5;
    &__logo {
      width: 220px;
      height: 220px;
    }
    &__text {
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
    }
  }
}
</style>
